type Size = 'sm' | 'md';
type Color = 'white' | 'red' | 'green';

const sizeClass: Record<Size, string> = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
};

const colorClass: Record<Color, string> = {
    white: 'border-white',
    red: 'border-red-500',
    green: 'border-backgroundGreen',
};

interface SpinnerProps {
    size?: Size;
    color?: Color;
}

export const Spinner = ({ size = 'md', color = 'white' }: SpinnerProps) => (
    <div
        role="status"
        aria-label="Loading"
        className={`animate-spin rounded-full border-b-2 ${sizeClass[size]} ${colorClass[color]}`}
    />
);
